import React, { useState, useEffect } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../services/firebase';
import { FirebaseError } from 'firebase/app';
import AuthLayout from './AuthLayout';
import { useLocation } from 'react-router-dom';

const validateEmail = (email: string) =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

const ForgotPasswordPage: React.FC = () => {
  

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [linkSent, setLinkSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
 

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setSubmitted(true);

    if (!email.trim()) return;
    if (!validateEmail(email)) {
      setError('Please enter a valid email.');
      return;
    }

    setLoading(true);

    try {
      setIsSubmitting(true);
      const res = await fetch('/.netlify/functions/forgot-password-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      console.log('User existence check response:', data);
      if (!res.ok) {
        throw new Error(data.error || 'Failed to send reset link');
        setError('Failed to send reset link. Please try again.');
      } else {
        setMessage('We’ve sent a password reset link to your email.');
        setError('')
        setLinkSent(true);
      }
    } catch (err: unknown) {
      const firebaseError = err as FirebaseError;
      setError(firebaseError.message || 'Failed to send reset link. Please try again.');
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const isFormValid = validateEmail(email);

  return (
    <AuthLayout title="Reset Password">
      <form onSubmit={handleSubmit}>
        <div className="formGroup">
          <input
            type="email"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError('');
              setMessage('');
            }}
            required
            autoFocus={true}
          />
        </div>
        <button
          type="submit"
          className="btnStyle"
          disabled={!isFormValid || loading || linkSent}
        >
          {loading ? 'Processing...' : linkSent ? 'Link Sent' : 'Continue'}
        </button>

        {error && email.trim() !== '' && (
          <p className="text-red-600">{error}</p>
        )}
        {message && (
          <p className="text-green-600">{message}</p>
        )}
      </form>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
